import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';

import { ProjectBloc } from '@connect-services/client/blocs/project.bloc';
import { MapFilterService } from '@connect-services/client/services/map-filter.service';
import { ProjectSessionStorageService } from '@connect-services/client/services/project-session-storage.service';
import {
    ButtonComponent,
    ButtonType,
    IconPosition,
} from '@connect-services/src/lib/components/button/button.component';
import { MapFilter } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-active-filter-item',
    templateUrl: './active-filter-item.component.html',
})
export class ActiveFilterItemComponent {
    public readonly filter: InputSignal<MapFilter> = input.required<MapFilter>();
    public readonly isInDropDown: InputSignal<boolean> = input<boolean>(false);

    protected readonly ButtonType = ButtonType;
    protected readonly IconPosition = IconPosition;
    protected readonly mapFilterService: MapFilterService = inject(MapFilterService);
    protected readonly projectBloc: ProjectBloc = inject(ProjectBloc);
    protected readonly projectSessionStorageService: ProjectSessionStorageService =
        inject(ProjectSessionStorageService);

    protected disableFilter(): void {
        this.mapFilterService.selectedFilters.update((filterIds: string[]) => {
            return filterIds.filter((id: string) => id !== this.filter().id);
        });

        this.projectSessionStorageService.updateSelectedFilter(
            this.projectBloc.value()!.id,
            this.mapFilterService.selectedFilters(),
        );
    }
}
